import { centralCharacterIds, eventsVisibleAt, getCharacter, getMoment, resolveCharacterState } from "../domain/engine";
import { mergeDetectedIssues } from "../domain/continuity";
import { StatusBadge } from "../components/ui";
import { useStore } from "../store";
import { useHash } from "../components/ui";

export function Dashboard() {
  const { bible, selection } = useStore();
  const [, navigate] = useHash();
  if (!bible) return null;
  const moment = getMoment(bible, selection.momentId);
  const recent = moment
    ? eventsVisibleAt(bible, moment.id).slice(-5).reverse()
    : eventsVisibleAt(bible, null, { bookId: selection.bookId }).slice(-5).reverse();
  const ids = centralCharacterIds();
  const issues = mergeDetectedIssues(bible).filter((i) => i.state === "open" || i.state === "decision-needed");

  return (
    <div className="grid">
      <div className="row space">
        <h1>Tableau de bord</h1>
        <button className="btn primary" type="button" onClick={() => navigate("/contexte")}>
          Préparer l’écriture
        </button>
      </div>
      <div className="grid grid-2">
        <section className="card">
          <h2>Événements</h2>
          <div className="list">
            {recent.slice(0, 5).map((e) => (
              <button key={e.id} className="item" type="button" onClick={() => navigate("/chronologie")}>
                <strong>{e.title}</strong>
                <div className="tiny">{e.momentId} · {e.summary}</div>
              </button>
            ))}
            {!recent.length && <p className="empty">Aucun événement pour cette lentille.</p>}
          </div>
        </section>
        <section className="card">
          <h2>Personnages centraux</h2>
          <div className="list">
            {ids.map((id) => {
              const c = getCharacter(bible, id);
              if (!c) return null;
              const st = resolveCharacterState(bible, id, selection.momentId);
              return (
                <button key={id} className="item" type="button" onClick={() => navigate(`/personnages/${id}`)}>
                  <div className="row space">
                    <strong>{c.name}</strong>
                    <StatusBadge status={c.status} />
                  </div>
                  <div className="tiny">
                    {st?.className} {st?.rank ? `· ${st.rank}e` : ""} {st?.lifeStatus && st.lifeStatus !== "alive" ? `· ${st.lifeStatus}` : ""}
                    {st?.location ? ` · ${st.location}` : ""}
                    {selection.momentId ? "" : " · trajectoire complète"}
                  </div>
                </button>
              );
            })}
          </div>
        </section>
        <section className="card">
          <h2>Intrigues ouvertes</h2>
          <p className="tiny">Arcs encore actifs. Les objectifs de classement ne sont pas des rangs atteints.</p>
          <button className="btn" type="button" onClick={() => navigate("/arcs")}>Voir les arcs</button>
        </section>
        <section className="card">
          <h2>Continuité</h2>
          {issues.slice(0, 4).map((i) => (
            <p key={i.id} className={i.severity === "critical" ? "warn" : "tiny"}>
              [{i.severity}] {i.title}
            </p>
          ))}
          <button className="btn" type="button" onClick={() => navigate("/continuite")}>
            Registre complet
          </button>
        </section>
      </div>
    </div>
  );
}
